import Component from '@cell/cell-core/component/component';
import './tabs.scss';

class Tabs extends Component {
  constructor() {
    super();

    this.elements = {
      tabsHeader: this.querySelector('.Tabs__Header'),
      tabButtons: this.querySelectorAll('.TabButton'),
      tabContents: this.querySelectorAll('.TabContent'),
    };

    this.handleResize = this.handleResize.bind(this);
  }

  componentDidMount() {
    this.determineScrollableState();

    globalThis.on('resize', this.handleResize);

    this.elements.tabButtons.forEach((tabButton) => {
      tabButton.addEventListener('click', () => {
        this.handleTabButtonClick(tabButton);
      });
    });
  }

  handleResize() {
    this.determineScrollableState();
  }

  determineScrollableState() {
    const { tabsHeader } = this.elements;
    const shouldBeScrollable = tabsHeader.scrollWidth > tabsHeader.offsetWidth;

    tabsHeader.classList.toggle('Tabs__Header--Scrollable', shouldBeScrollable);
    tabsHeader.classList.toggle('u-NoScrollbar', shouldBeScrollable);
  }

  handleTabButtonClick(tabButton) {
    const handle = tabButton.getAttribute('data-tab-button-for');

    this.updateTabContentsActiveState(handle);
    this.updateTabButtonsActiveState(tabButton);
  }

  /**
   * Adds the active state class to the clicked tab button and removes it from all other buttons.
   *
   * @param {HTMLElement} clickedButton -
   */
  updateTabButtonsActiveState(clickedButton) {
    this.elements.tabButtons.forEach((button) => {
      const shouldBeActive = button === clickedButton;

      button.classList.toggle('TabButton--Active', shouldBeActive);
    });
  }

  /**
   * Adds the active state class to the tab content element that is connected to the clicked tab
   * button.
   *
   * @param {string} clickedHandle -
   */
  updateTabContentsActiveState(clickedHandle) {
    this.elements.tabContents.forEach((tabContent) => {
      const handle = tabContent.getAttribute('data-tab-content');
      const shouldBeActive = handle === clickedHandle;

      tabContent.classList.toggle('TabContent--Active', shouldBeActive);
    });
  }
}

customElements.define('c-tabs', Tabs);
